import { requestGet, requestPost, requestPut, requestDelete } from "../config/Api";

export const getRoles = () => {
  return requestGet("roles");
};
export const getUsers = () => {
  return requestGet("user");
};

export const createUser = (user) => {
  return requestPost("user", user);
};

export const updateUser = (id, user) => {
  return requestPut(`user/${id}`, user);
};

export const deleteUser = (id) => {
  return requestDelete(`user/${id}`);
};

export const updateUserPassword = (id, data) =>
  requestPut(`/user/${id}/password`, data);

export const getUserDirectPermissions = (id) =>
  requestGet(`user/direct/permissions/${id}`);

export const updateUserDirectPermissions = (id, data) =>
  requestPut(`user/direct/permissions/${id}`, data);